import { render, staticRenderFns } from "./onKlav.vue?vue&type=template&id=6c85f6b0"
import script from "./onKlav.vue?vue&type=script&lang=js"
export * from "./onKlav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports